/* eslint-disable dot-notation */
/* global document */
import queryString from 'query-string'
import _ from 'lodash'
import Cookies from 'js-cookie'

const getHostname = url => {
  const l = document.createElement('a')
  l.href = url
  return l.hostname
}

const IsSearchEngine = url => {
  const rgx = /google|bing|yahoo|ask|baidu|yandex|blekko|ixquick|startpage|duckduckgo|dogpile|excite|altavista|teoma|hakia|aol|lycos|activesearch|apexoo|blackle|cluuz|compuservesearch|entireweb|exalead|hotbot|lexxe|mojeek|nexplore|scrubtheweb|seekfu|visvo|yippy|biomedsearch|infomine|intute|ipl2|nihilscio|omnimedicalsearch|q-sensei|quertle|refseek|scirus|searchmedia|sweetsearch|vadlo|virtuallearningresourcescente|findsounds|radioscout|icerocket|magportal|newslookupcom|silobreaker|technorati|ebooksearchqueen|findpdf|foofind|pdfsciencesearch|pptsearch365|printfu|slidefinder|panjoy|recipebridge|yummly|boardreader|omgili|incogna|macroglossa|picsearch|qualityimagesearch|behold|compfight|digitalinspiration|picfog|pixolu2|twicsy|twipho|twitcaps|webstagram|everystockphoto|picfindr|facesaerch|imensepicturesearch|tineyereverseimagesearch|vectorus|findicons|iconseeker|iconfinder|iconlet|iconspedia|icons-search|veryicon|oskope|blinkx|casttv|clipflakestv|strimoo|trooker|ifacnet|lexisweb|simplyhired|webc-i|123people|isearch|lullar|peekyou|pipl|spokeo|sysoon|whozat|wink|zoominfo|goonux|merobase|roozzy|rsssearchhub|search[code]|searchirc|shodan|surfwax|swoogle|sengineinfo|thunderstone|colorof|copernic|ecofreek|eudicteu|factbites|faroo|googleminusgoogle|greenmaven|querycat|seeks|seesourcescom|snappyfingers|stylig|tripatde|verticalsearch|zanran|abacho|ecosia|everyclick|goodsearch|ripple|similarpages|similarsitesearch|similicious|siteslikesites|annox|fooxx|searchteam|slikk|kurrently|sency|socialsearch|socialsearcher|spezify|tinker|topsy|twitority|amfibi|apocalx|apollo7|carrot2|cosmoage|devilfinder|elocalfinder|finday|forelook|fuzzfind|geegain|gnome|gokookygo|goofram|gopher|harvester42|inetmonster|iboogie|infocom|iseek|lookallweb|mamma|metabear|metacrawler|monstercrawler|opentextfederatedqueryserver|oxysearch|polymeta|qksearch|qrobe|riight|roysearch|scandoo|search|searches|sgyba|sperse|squikoo|stinkyteddy|turboscout|webcrawler|webfetch|webnocular|yometa|zapmeta|searchnigeria|258com|2881com|antsocom|gougoucom|sinogoo|sogou|soso|sunwukong|youdao|zhongsoucom|biglobe|ceekjp|fresheye|goo|metchasearch|multifind|spysee|daum|nate|naver|simmanicom|alleba|gurujicom|rediff|sifycom|ilse|jaanbe|metaseek|vindennl|zoeknl|babygo|doona|echonimo|infoseek|seekfr|toileduquébec|vatrouver|vigoos|voila|öko-anbieterde|acoon|allefragennet|base:bielefeldacademicsearch|blindekuh|clewwa|deligoo|deutscheseitende|diekraehe|digibib|discounto|fastbot|financierode|fireball|infowebweiterbildung-iwwb|lixamde|marketing-searchde|metager|metager2|metascroll|metaspinner|meteora|ministeriennet|netluchsde|oneseekde|qualigo|semager|suchende|t-online|vebidoo|vs-maschinenbau|yabado|yasnide|etoolsch|searchch|anazitisis|ano-kato|visto|aristotele|gjlgmetamotore|iltrovatore|iusseek|libero-ricerca|virgilio|volunia|webtracer|eniro|jubii|seekse|elisanet|leitis|diri|jabse|jyxo|klábosenícz|seznam|fórumkereso|gizikehu|johu|lapozzhu|okhu|wywkereso|delfi|goorupl|netsprint|usernamero|srpko|morfeo|najdisi|buscar|iol|sapo|sitedebusca|uolbusca|hispavista|laiesken|terra|xaarkymetabuscador|enxogo|huubs|olmazmicom|1elru|agropoiskru|bukinist|codavrru|gomailru|ljpoiskru|metabotru|metabrain|nigmaru|quintura|rambler|yottos|yamli|behjoo|irpars|jamasp|parseek|walla!|webwombat|ansearch|deeperweb|exactseek|findelio|geona|gigablast|heapr|incywincy|kidrex|managedq|mundusearch|myallsearch|mywebsearch|oolone|pepesearch|pesquisarorg|redz|scour|search66|searchhippo|simploos|slider|spacetime3d|surfcanyon|tagsup|thenet1|twurdy|agent55|askboth|blindsearch|draze|giapeto|graball|manyget|multisearching|multiplesearch|mysearchit|nowgoogle|polycola|searchgby|searchboth|searchezee|seeaarch|targ8|topsite|trovandoit|twingine|wotbox|yabigo|zuula|browsys|kvasir|searchqik|onelook|thiv|soorsa|moresearchbiz|woopietv|soku/gi
  const matches = url.match(rgx)
  return matches && matches.length > 0
}

const expireDate = () => {
  const date = new Date()
  date.setDate(date.getDate() + 90)

  return date
}

export default () => {
  let firstUserCookie =
    Cookies.get('hult_Firstusercookie') &&
    queryString.parse(Cookies.get('hult_Firstusercookie'))
  let userCookie =
    Cookies.get('hult_usercookie') &&
    queryString.parse(Cookies.get('hult_usercookie'))
  const requestQuery = queryString.parse(document.location.search)
  const referrer = queryString.parseUrl(document.referrer)

  let isReferral = false
  let isOrganic = false
  const expiresAt = expireDate()

  if (document.referrer && !_.includes(document.referrer, 'hult.edu')) {
    if (IsSearchEngine(referrer.url)) {
      isOrganic = true
    } else {
      isReferral = true
    }
  }

  if (!firstUserCookie) {
    firstUserCookie = {}
    if (requestQuery['gclid']) {
      firstUserCookie['firstwebpartner'] = 'GoogleAdwords'
      firstUserCookie['firstwebmedium'] = 'cpc'
    } else if (requestQuery['utm_source']) {
      firstUserCookie['firstwebpartner'] = requestQuery['utm_source']
    } else if (isReferral) {
      firstUserCookie['firstwebpartner'] = 'GMAC CE'
      firstUserCookie['firstwebcampaign'] = getHostname(referrer.url)
    } else if (isOrganic) {
      firstUserCookie['firstwebpartner'] = 'Organic'
      firstUserCookie['firstwebcampaign'] = getHostname(referrer.url)
    } else {
      firstUserCookie['firstwebpartner'] = 'GMAC CE'
    }

    if (requestQuery['elq']) {
      firstUserCookie['firsteloquaEmail'] = requestQuery['utm_campaign'] || ''
    }
    if (requestQuery['utm_campaign']) {
      firstUserCookie['firstwebcampaign'] = requestQuery['utm_campaign']
    }
    if (requestQuery['utm_term']) {
      firstUserCookie['firstwebterm'] = requestQuery['utm_term']
    }
    if (requestQuery['utm_medium']) {
      firstUserCookie['firstwebmedium'] = requestQuery['utm_medium']
    }
    if (requestQuery['utm_content']) {
      firstUserCookie['firstwebcontent'] = requestQuery['utm_content']
    }
    if (requestQuery['utm_adgroup']) {
      firstUserCookie['firstwebadgroup'] = requestQuery['utm_adgroup']
    }
    if (requestQuery['utm_placement']) {
      firstUserCookie['firstwebplacement'] = requestQuery['utm_placement']
    }
    if (requestQuery['e']) {
      firstUserCookie['firsttouchrecipientemail'] = requestQuery['e']
    }
    if (requestQuery['j']) {
      firstUserCookie['j'] = requestQuery['j']
    }
    if (requestQuery['campaign_Id']) {
      firstUserCookie['campaign_Id'] = requestQuery['campaign_Id']
    }

    Cookies.set(
      'hult_Firstusercookie',
      queryString.stringify(firstUserCookie),
      {
        path: '/',
        expires: expiresAt,
        sameSite: 'None',
        secure: true
      }
    )
  }

  if (!userCookie) {
    userCookie = {}
  }

  if (document.referrer) {
    userCookie['referrer_url'] = document.referrer
  }

  if (requestQuery['gclid']) {
    userCookie['webpartner'] = 'GoogleAdwords'
    userCookie['webmedium'] = 'cpc'
  } else if (requestQuery['utm_source'] != null) {
    userCookie['webpartner'] = requestQuery['utm_source']
  } else if (isReferral) {
    userCookie['webpartner'] = 'GMAC CE'
    userCookie['webcampaign'] = getHostname(referrer.url)
  } else if (isOrganic) {
    userCookie['webpartner'] = 'Organic'
    userCookie['webcampaign'] = getHostname(referrer.url)
  }

  if (requestQuery['elq']) {
    userCookie['eloquaEmail'] = requestQuery['utm_campaign'] || ''
  }
  if (requestQuery['utm_campaign']) {
    userCookie['webcampaign'] = requestQuery['utm_campaign']
  }
  if (requestQuery['utm_term']) {
    userCookie['webterm'] = requestQuery['utm_term']
  }
  if (requestQuery['utm_medium']) {
    userCookie['webmedium'] = requestQuery['utm_medium']
  }
  if (requestQuery['utm_content']) {
    userCookie['webcontent'] = requestQuery['utm_content']
  }
  if (requestQuery['utm_adgroup']) {
    userCookie['webadgroup'] = requestQuery['utm_adgroup']
  }
  if (requestQuery['utm_placement']) {
    userCookie['webplacement'] = requestQuery['utm_placement']
  }

  if (requestQuery['e']) {
    userCookie['recipientemail'] = requestQuery['e']
  }
  if (requestQuery['j']) {
    userCookie['j'] = requestQuery['j']
  }
  if (requestQuery['campaign_Id']) {
    userCookie['campaign_Id'] = requestQuery['campaign_Id']
  }

  Cookies.set('hult_usercookie', queryString.stringify(userCookie), {
    path: '/',
    expires: expiresAt,
    sameSite: 'None',
    secure: true
  })
}

export const getCookieData = (formData = {}) => {
  const firstUserCookie = Cookies.get('hult_Firstusercookie')
    ? queryString.parse(Cookies.get('hult_Firstusercookie'))
    : []
  const userCookie = Cookies.get('hult_usercookie')
    ? queryString.parse(Cookies.get('hult_usercookie'))
    : []

  formData.partnerCode = userCookie['webpartner'] || 'GMAC CE'
  formData.webCampaign = userCookie['webcampaign'] || ''
  formData.webMedium = userCookie['webmedium'] || ''
  formData.webTerm = userCookie['webterm'] || ''
  formData.webContent = userCookie['webcontent'] || ''
  formData.webAdgroup = userCookie['webadgroup'] || ''
  formData.webPlacement = userCookie['webplacement'] || ''
  formData.firstpartnerCode = firstUserCookie['firstwebpartner'] || 'GMAC CE'
  formData.firstwebCampaign = firstUserCookie['firstwebcampaign'] || ''
  formData.firstwebMedium = firstUserCookie['firstwebmedium'] || ''
  formData.firstwebTerm = firstUserCookie['firstwebterm'] || ''
  formData.firstwebContent = firstUserCookie['firstwebcontent'] || ''
  formData.firstwebAdgroup = firstUserCookie['firstwebadgroup'] || ''
  formData.firstwebPlacement = firstUserCookie['firstwebplacement'] || ''
  formData.referringUrl = userCookie['referrer_url'] || ''
  formData.eloquaEmail = userCookie['eloquaEmail'] || ''
  formData.firsteloquaEmail = firstUserCookie['firsteloquaEmail'] || ''
  formData.recipientEmail = userCookie['recipientemail'] || ''
  formData.firstRecipientEmail =
    firstUserCookie['firsttouchrecipientemail'] || ''
  formData.pillarEmailJobId = (userCookie && userCookie['j']) || ''
  if (document) formData.url = document.location.href

  return formData
}
